import { Component, Input, OnChanges } from '@angular/core';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import {
    Purchase,
    PurchaseStatus
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { StatusColor } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ExpandableRowsService } from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';
import { of } from 'rxjs';
import { EnumDisplay } from '../../../../../../constants/enum-display.constants';

@Component({
    selector: 'purchases-by-customer-mobile-grouped-table',
    template: `
        <lsq-data-table-mobile [dataSource]="dataSource" [initializeFirstOpen]="groupIndex === 0">
            <ng-template #mobileCardHeader let-row="row">
                <div class="purchases-mobile-table-header">
                    <div class="mtc-header-content-left">
                        <div class="mtc-header-title">
                            Purchase
                        </div>
                        <div class="mtc-header-sub-title">
                            Amount:&nbsp;
                            {{ row.purchaseAmount | lsqCurrency }}
                        </div>
                    </div>
                    <div class="mtc-header-content-right">
                        <div class="mtc-header-status-text">
                            <div class="status-wrapper">
                                <span
                                    *ngIf="
                                        row.purchaseStatus &&
                                        enumDisplay.PurchasesStatus[row.purchaseStatus]
                                    "
                                >
                                    <span
                                        [innerHtml]="
                                            enumDisplay.PurchasesStatus[row.purchaseStatus]
                                        "
                                    ></span>
                                </span>
                            </div>
                            <span
                                *ngIf="
                                    row.purchaseStatus &&
                                    statusColor[purchaseStatus[row.purchaseStatus]]
                                "
                                [ngStyle]="{ paddingRight: '0.75rem' }"
                            >
                                <lsq-icon
                                    [type]="icons.Circle"
                                    [color]="statusColor[purchaseStatus[row.purchaseStatus]]"
                                ></lsq-icon>
                            </span>
                        </div>
                    </div>
                </div>
                <ng-template #mobileCardColumns let-row="row">
                    <div class="card-item">
                        <div class="card-item-label">
                            Upload #
                        </div>
                        <div class="card-item-value">
                            {{ row.batchNumber }}
                        </div>
                    </div>
                    <div class="card-item">
                        <div class="card-item-label">
                            Amount
                        </div>
                        <div class="card-item-value">
                            {{ row.purchaseAmount | lsqCurrency }}
                        </div>
                    </div>
                    <div class="card-item">
                        <div class="card-item-label">
                            Denied
                        </div>
                        <div class="card-item-value">
                            {{ row.deniedAmount | lsqCurrency }}
                        </div>
                    </div>
                    <div class="card-item">
                        <div class="card-item-label">
                            Ineligibles
                        </div>
                        <div class="card-item-value">
                            {{ row.ineligibleAmount | lsqCurrency }}
                        </div>
                    </div>
                    <div class="card-item">
                        <div class="card-item-label">
                            Fees
                        </div>
                        <div class="card-item-value">
                            {{ row.purchaseFees | lsqCurrency }}
                        </div>
                    </div>
                </ng-template>
                <ng-template #mobileCardFooter let-row="row">
                    <div class="mtc-footer-link">
                        <lsq-button
                            appearance="transparent"
                            (buttonClick)="handleMobileTableCardFooterClick(row)"
                            i18n="Table column button to view invoices"
                        >
                            Invoice Details
                        </lsq-button>
                    </div>
                </ng-template>
            </ng-template>
        </lsq-data-table-mobile>
    `,
    styleUrls: ['./purchases-by-customer.mobile-grouped-table.components.scss']
})
export class PurchasesByCustomerMobileGroupedTableComponent implements OnChanges {
    @Input() public rows: Purchase[];
    @Input() public groupIndex: number;
    @Input() public expandableRowsService: ExpandableRowsService;

    public dataSource: LsqListSource<Purchase>;

    // Constants.
    public statusColor = StatusColor;
    public icons = Icons;
    public purchaseStatus = PurchaseStatus;
    public enumDisplay = EnumDisplay;
    public placement = PopoverPlacement;

    public ngOnChanges(): void {
        this.dataSource = new LsqListSource<Purchase>({
            rows$: of(this.rows)
        });
    }

    public handleMobileTableCardFooterClick(row: any): void {
        this.expandableRowsService.expand(row);
    }
}
